import { FunctionComponent, memo } from "react";

import { IProps } from "./writing-issue-table-menu.types";
import "./writing-issue-table-menu.scss";
import { formatEnumOptions, TableMenuSection } from "@edgetier/client-components";
import TableMenuFilterList from "components-for/tables/table-menu-filter-list";
import { WritingIssueType } from "@edgetier/watchtower-types";

/**
 * A table meny for filtering by writing issue type.
 * @param props.onClick A function to run when a menu item is clicked.
 * @param props.value   The value that has been selected.
 */
const WritingIssueTableMenu: FunctionComponent<IProps> = ({ onClick, value }) => (
    <TableMenuSection>
        <TableMenuFilterList
            labelProperty="label"
            items={formatEnumOptions(WritingIssueType)}
            valueProperty="value"
            value={value}
            onClick={onClick}
        />
    </TableMenuSection>
);

export default memo(WritingIssueTableMenu);
